import aplusExparams from '@alife/bc-aplus-exparams';
import safeLog from '@alife/bc-safe-log';

const jsLoadedTime = Date.now();

function initPerf() {
  window.__feReady = true;
  const { timing } = window.performance || {};
  const {
    navigationStart,
    redirectStart,
    fetchStart,
    domainLookupEnd,
    requestStart,
    responseStart,
  } = timing || {};
  if (navigationStart) {
    const execTime = Date.now();
    const treq = aplusExparams.get('treq');
    const tres = aplusExparams.get('tres');
    window.__BB = window.__BB || {};
    window.__BB.extendParams = Object.assign({}, window.__BB.extendParams, {
      unload: redirectStart - navigationStart,
      redirect: fetchStart - navigationStart,
      dns: domainLookupEnd - navigationStart,
      connect: requestStart - navigationStart,
      treq: treq - navigationStart,
      tres: tres - navigationStart,
      ttfb: responseStart - navigationStart,
      docStart: window._pageStartTime - navigationStart,
      fstpage: window._pageFirstScreenTime - navigationStart,
      allpage: window._pageReadyTime - navigationStart,
      jsLoad: jsLoadedTime - navigationStart,
      jsExec: execTime - navigationStart,
      boothimage:
        (window._boothImageReady || new Date().getTime()) - navigationStart,
      boothimage2:
        window._boothImageReadyWithFlasher !== undefined
          ? window._boothImageReadyWithFlasher - navigationStart
          : null,
      navStart: navigationStart,
      boothimageWithFlasher: window._boothImageReadyWithFlasher,
      cssStartTime: window._cssStartTime - navigationStart,
      cssEndTime: window._cssEndTime - navigationStart,
    });
  }
  if (window.performance) {
    const navgationTiming = window.performance.getEntries()[0];
    const { decodedBodySize, encodedBodySize } = navgationTiming;
    if (decodedBodySize && encodedBodySize) {
      safeLog(
        '/sc.details.htmlSize',
        'OTHER',
        `encodedBodySize=${parseInt(
          encodedBodySize / 1000,
          10,
        )}&decodedBodySize=${parseInt(decodedBodySize / 1000, 10)}`,
        'GET',
      );
    }
  }
}

export default initPerf;
